export enum ProcessingStatus {
    NEW = 'new',
    PENDING = 'pending',
    CHANGING = 'changing',
    COMPLETE = 'complete',
    ERROR = 'error',
    NOTSET = 'notset',
    NONE = '',
}

export function isTerminalProcessingStatus(status: ProcessingStatus) {
    return (
        status === ProcessingStatus.COMPLETE ||
        status === ProcessingStatus.ERROR
    );
}
